import { render, staticRenderFns } from "./OverviewDocumentNode.vue?vue&type=template&id=68f19c38&scoped=true"
import script from "./OverviewDocumentNode.vue?vue&type=script&lang=js"
export * from "./OverviewDocumentNode.vue?vue&type=script&lang=js"
import style0 from "./OverviewDocumentNode.vue?vue&type=style&index=0&id=68f19c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f19c38",
  null
  
)

export default component.exports